module.exports = __webpack_public_path__ + "static/media/collapse.616886e3.svg";